import { format } from "date-fns";

/**
 * Email address / date formatting helpers for the Gmail import modal.
 *
 * Gmail surfaces dates as raw RFC 2822 header strings and addresses in
 * "Name <email>" form; these helpers normalise both for display.
 */

/** Parse a raw email date header into a Date, or `null` when unparseable. */
export function parseEmailDate(dateStr: string): Date | null {
    if (!dateStr) return null;
    try {
        const d = new Date(dateStr);
        return isNaN(d.getTime()) ? null : d;
    } catch {
        return null;
    }
}

/** Format a raw email date header for display, falling back to the raw string. */
export function formatEmailDate(dateStr: string): string {
    const d = parseEmailDate(dateStr);
    if (!d) return dateStr;
    return format(d, "MMM d, yyyy h:mm a");
}

/** Extract just the email address from "Name <email>" format. */
export function extractEmail(raw: string): string {
    const match = raw.match(/<([^>]+)>/);
    return match ? match[1] : raw;
}

/** Extract the display name from "Name <email>" format. */
export function extractName(raw: string): string {
    const match = raw.match(/^([^<]+)</);
    return match ? match[1].trim().replace(/^["']|["']$/g, "") : extractEmail(raw);
}
